import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Upload, FolderPlus, Users, Image, Settings, Share2 } from 'lucide-react';
import Header from '../components/Header';
import PhotoUpload from '../components/PhotoUpload';
import FolderManager from '../components/FolderManager';
import UserManager from '../components/UserManager';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import { fetcheventsRequest } from '../store/slice/events/events.slice';

const AdminDashboard = () => {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { events, loading, error ,eventsCount,imageCount} = useSelector((state) => state.events);

  useEffect(() => {
    if (!loading && !error) {
      dispatch(fetcheventsRequest());
    }
  }, []);

  const tabs = [
    { id: 'upload', label: 'Upload Photos', icon: Upload },
    { id: 'events', label: 'Manage events', icon: FolderPlus },
    { id: 'users', label: 'User Management', icon: Users },
    { id: 'settings', label: 'Settings', icon: Settings },
  ];

  const stats = [
    { label: 'Total Photos', value: imageCount, icon: Image, color: 'bg-blue-500' },
    { label: 'Active Users', value: '89', icon: Users, color: 'bg-emerald-500' },
    { label: 'events Created', value: eventsCount, icon: FolderPlus, color: 'bg-purple-500' },
    { label: 'Shares Generated', value: '156', icon: Share2, color: 'bg-orange-500' },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
     
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Welcome Section */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Welcome back, {user?.name}
          </h1>
          <p className="text-gray-600">Manage your photo storage system from this dashboard</p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-gray-600 mb-1">{stat.label}</p>
                  <p className="text-3xl font-bold text-gray-900">{stat.value}</p>
                </div>
                <div className={`p-3 rounded-full ${stat.color}`}>
                  <stat.icon className="h-6 w-6 text-white" />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Tabs */}
        {/* <div className="bg-white rounded-xl shadow-sm border border-gray-100 mb-8">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                    activeTab === tab.id
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <tab.icon className="h-5 w-5" />
                  <span>{tab.label}</span>
                </button>
              ))}
            </nav>
          </div>

          <div className="p-6">
            {activeTab === 'upload' && <PhotoUpload events={events} />}
            {activeTab === 'events' && <FolderManager events={events} setevents={setevents} />}
            {activeTab === 'users' && <UserManager />}
            {activeTab === 'settings' && (
              <div className="text-center py-12">
                <Settings className="h-16 w-16 text-gray-300 mx-auto mb-4" />
                <h3 className="text-lg font-medium text-gray-900 mb-2">Settings Panel</h3>
                <p className="text-gray-500">System configuration options coming soon</p>
              </div>
            )}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AdminDashboard;